import { Dialog, DialogFooter, DialogType } from '@fluentui/react';
import React from 'react';
import { BwjButton, BwjButtonType } from '../bwj-button';

interface IBwjNavigationWarningUiProps {
  show: boolean;
  title: string;
  warning: string;
  proceedPrompt: string;
  cancelPrompt: string;
  onProceedRequested: Function;
  onCancelRequested: Function;
}

const componentStyles = {
  main: {
    maxWidth: 450,
  }
}

export const BwjNavigationWarningUi: React.FunctionComponent<IBwjNavigationWarningUiProps> = (props) => {

  return (
    <Dialog
    hidden={props.show === false}
    dialogContentProps={{
      type: DialogType.normal,
      title: props.title,
      subText: props.warning,
    }}
    modalProps={{
      isBlocking: true,
      styles: componentStyles,
    }}
    >
      <DialogFooter>
        <BwjButton
          buttonStyle={BwjButtonType.PrimaryStandard}
          text={props.proceedPrompt}
          onClick={() => props.onProceedRequested()}
        />
        <BwjButton
          buttonStyle={BwjButtonType.DefaultStandard}
          text={props.cancelPrompt}
          onClick={() => props.onCancelRequested()}
        />
      </DialogFooter>
    </Dialog>
  );
};
